import React from "react";

import "./Soundwave.scss";

export const Soundwave: React.FC = () => (
  <svg className="soundwave" viewBox="0 0 100 100" width="100" height="100">
    <circle r="50" cx="50" cy="50" vector-effect="non-scaling-stroke">
      <animate dur="6s" values="1;0" keySplines="0.18 0.92 0.57 0.97" calcMode="spline" attributeName="stroke-opacity" repeatCount="indefinite" />
      <animate dur="6s" values="0;50" keySplines="0.18 0.92 0.57 0.97" calcMode="spline" attributeName="r" repeatCount="indefinite" />
    </circle>
    <circle r="50" cx="50" cy="50" vector-effect="non-scaling-stroke">
      <animate dur="6s" values="1;0" keySplines="0.18 0.92 0.57 0.97" calcMode="spline" attributeName="stroke-opacity" repeatCount="indefinite" begin="1s" />
      <animate dur="6s" values="0;50" keySplines="0.18 0.92 0.57 0.97" calcMode="spline" attributeName="r" repeatCount="indefinite" begin="1s" />
    </circle>
    <circle r="50" cx="50" cy="50" vector-effect="non-scaling-stroke">
      <animate dur="6s" values="1;0" keySplines="0.18 0.92 0.57 0.97" calcMode="spline" attributeName="stroke-opacity" repeatCount="indefinite" begin="2s" />
      <animate dur="6s" values="0;50" keySplines="0.18 0.92 0.57 0.97" calcMode="spline" attributeName="r" repeatCount="indefinite" begin="2s" />
    </circle>
    <circle r="50" cx="50" cy="50" vector-effect="non-scaling-stroke">
      <animate dur="6s" values="1;0" keySplines="0.18 0.92 0.57 0.97" calcMode="spline" attributeName="stroke-opacity" repeatCount="indefinite" begin="3s" />
      <animate dur="6s" values="0;50" keySplines="0.18 0.92 0.57 0.97" calcMode="spline" attributeName="r" repeatCount="indefinite" begin="3s" />
    </circle>
    <circle r="50" cx="50" cy="50" vector-effect="non-scaling-stroke">
      <animate dur="6s" values="1;0" keySplines="0.18 0.92 0.57 0.97" calcMode="spline" attributeName="stroke-opacity" repeatCount="indefinite" begin="4s" />
      <animate dur="6s" values="0;50" keySplines="0.18 0.92 0.57 0.97" calcMode="spline" attributeName="r" repeatCount="indefinite" begin="4s" />
    </circle>
    <circle r="50" cx="50" cy="50" vector-effect="non-scaling-stroke">
      <animate dur="6s" values="1;0" keySplines="0.18 0.92 0.57 0.97" calcMode="spline" attributeName="stroke-opacity" repeatCount="indefinite" begin="5s" />
      <animate dur="6s" values="0;50" keySplines="0.18 0.92 0.57 0.97" calcMode="spline" attributeName="r" repeatCount="indefinite" begin="5s" />
    </circle>
  </svg>
);
